/* Pie de árbol personalizado · Hogar Colombia
   Packs (1, 2 o 3 unidades), personalizador en vivo por unidad, galería,
   comparador antes/después y CTA fijo. Sin librerías. Todo vive dentro de #hcpa. */
(function () {
  "use strict";

  var CONFIG = {
    maxLetras: 14,
    minLetras: 2,
    ejemplo: ["Castro", "López"],
    // Zona del nombre en la foto plana (coordenadas de la imagen de 900 × 866 px).
    zona: { centroX: 471, base: 685, anchoMax: 360, tamano: 54, tamanoMin: 30 },
    vistas: { cerca: "171 496 600 338", completo: "0 0 900 866" },
    packs: [
      { unidades: 1, precio: 139900, emoji: "🎄", titulo: "1 unidad", gancho: "Para tu árbol",
        desc: "El apellido de tu familia brillando en tu sala este diciembre." },
      { unidades: 2, precio: 229900, emoji: "🎁", titulo: "2 unidades", gancho: "Tu casa + un regalo", chip: "Para regalar",
        desc: "Uno para ti y otro para mamá, la suegra o tu hermana. Cada uno con su apellido." },
      { unidades: 3, precio: 339900, emoji: "🏡", titulo: "3 unidades", gancho: "Para toda la familia", chip: "Mejor precio",
        desc: "Tu casa, la de tus papás y la de tus suegros. El regalo que sí van a usar cada año." }
    ],
    packDestacado: 1 // índice del pack con la cinta dorada en la sección de precios
  };

  var raiz = document.getElementById("hcpa");
  if (!raiz) return;
  var $ = function (id) { return document.getElementById(id); };

  // En Shopify la sección imprime las variantes reales (id y precio) en #hcpa-datos.
  // Sin ese bloque (demo local) se usan los precios de CONFIG y el botón no compra.
  var tienda = null;
  try { tienda = JSON.parse($("hcpa-datos").textContent); } catch (e) { tienda = null; }
  // Dos formas de montar el producto en Shopify:
  //  · 3 variantes (1, 2 y 3 unidades): cada pack usa su variante y su precio, cantidad 1.
  //  · 1 variante + oferta por cantidad de Releasit: todos usan la misma variante con
  //    cantidad 1, 2 o 3; el descuento lo pone Releasit y los precios de CONFIG deben coincidir.
  if (tienda && tienda.variantes && tienda.variantes.length >= CONFIG.packs.length) {
    CONFIG.packs.forEach(function (p, i) {
      p.variante = tienda.variantes[i].id;
      p.precio = tienda.variantes[i].precio;
      p.disponible = tienda.variantes[i].disponible;
      p.cantidadForm = 1;
    });
  } else if (tienda && tienda.variantes && tienda.variantes.length === 1) {
    CONFIG.packs.forEach(function (p) {
      p.variante = tienda.variantes[0].id;
      p.disponible = tienda.variantes[0].disponible;
      p.cantidadForm = p.unidades;
    });
  } else {
    tienda = null;
  }

  var pesos = function (n) { return "$" + n.toLocaleString("es-CO"); };
  var unitario = CONFIG.packs[0].precio;
  var ahorro = function (p) { return unitario * p.unidades - p.precio; };
  var suave = function () { return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"; };

  /* ---------- Estado ---------- */
  var estado = {
    pack: 0,
    activa: 0,
    mismos: false,
    pies: [0, 1, 2].map(function () { return { ap1: "", ap2: "", ok: false }; })
  };
  var cantidad = function () { return CONFIG.packs[estado.pack].unidades; };
  var multiple = function () { return cantidad() > 1 && !estado.mismos; };
  var todosOk = function () {
    for (var i = 0; i < cantidad(); i++) if (!estado.pies[i].ok) return false;
    return true;
  };
  var primeroPendiente = function () {
    for (var i = 0; i < cantidad(); i++) if (!estado.pies[i].ok) return i;
    return -1;
  };

  var ap = [$("hcpa-ap1"), $("hcpa-ap2")];
  var contadores = [$("hcpa-c1"), $("hcpa-c2")];
  var errores = [$("hcpa-e1"), $("hcpa-e2")];
  var nombreSvg = $("hcpa-nombre");

  /* ---------- Apellidos ---------- */

  // Deja letras (con tildes, ñ, ü), espacios, guion y apóstrofo. Nada de números ni símbolos.
  function limpiar(valor) {
    var v = valor.replace(/[^\p{L}\s'’-]/gu, "").replace(/\s{2,}/g, " ").replace(/^\s+/, "");
    if (v) v = v.charAt(0).toLocaleUpperCase("es-CO") + v.slice(1);
    return v.slice(0, CONFIG.maxLetras);
  }
  function familia(a1, a2) { return ("Familia " + [a1, a2].filter(Boolean).join(" ")).trim(); }

  function ajustarTamano() {
    var z = CONFIG.zona;
    nombreSvg.removeAttribute("textLength");
    nombreSvg.removeAttribute("lengthAdjust");
    nombreSvg.style.fontSize = z.tamano + "px";
    var ancho = nombreSvg.getComputedTextLength();
    if (ancho <= z.anchoMax) return;
    nombreSvg.style.fontSize = Math.max(z.tamanoMin, z.tamano * z.anchoMax / ancho) + "px";
    // Si aun al mínimo no cabe, se comprime para no salirse de la zona imprimible.
    if (nombreSvg.getComputedTextLength() > z.anchoMax) {
      nombreSvg.setAttribute("textLength", z.anchoMax);
      nombreSvg.setAttribute("lengthAdjust", "spacingAndGlyphs");
    }
  }

  function pintarVista() {
    var p = estado.pies[estado.activa];
    var vacio = !p.ap1 && !p.ap2;
    var texto = vacio ? familia(CONFIG.ejemplo[0], CONFIG.ejemplo[1]) : familia(p.ap1, p.ap2);
    nombreSvg.textContent = texto;
    nombreSvg.classList.toggle("is-ejemplo", vacio);
    $("hcpa-chip-ejemplo").hidden = !vacio;
    $("hcpa-vista-titulo").textContent = "Vista previa: Feliz Navidad para la " + texto;
    ajustarTamano();
  }

  function cargarCampos() {
    var p = estado.pies[estado.activa];
    ap[0].value = p.ap1;
    ap[1].value = p.ap2;
    ap.forEach(function (input, i) {
      contadores[i].textContent = input.value.length + "/" + CONFIG.maxLetras;
      marcarError(i, "");
    });
  }

  function marcarError(i, msg) {
    errores[i].textContent = msg;
    if (msg) ap[i].setAttribute("aria-invalid", "true");
    else ap[i].removeAttribute("aria-invalid");
  }

  ap.forEach(function (input, i) {
    var campo = i === 0 ? "ap1" : "ap2";
    input.addEventListener("input", function () {
      var limpio = limpiar(input.value);
      if (limpio !== input.value) input.value = limpio;
      contadores[i].textContent = input.value.length + "/" + CONFIG.maxLetras;
      if (input.getAttribute("aria-invalid") === "true") marcarError(i, "");
      var destino = estado.mismos ? estado.pies : [estado.pies[estado.activa]];
      destino.forEach(function (p) { p[campo] = input.value.trim(); p.ok = false; });
      pintarVista();
      refrescar();
    });
    input.addEventListener("blur", function () { input.value = input.value.trim(); });
    // En celular, al escribir deja la vista previa arriba para verla junto al teclado.
    input.addEventListener("focus", function () {
      if (window.matchMedia("(max-width: 899px)").matches) {
        setTimeout(function () { $("hcpa-vista").scrollIntoView({ block: "start", behavior: suave() }); }, 250);
      }
    });
  });
  ap[0].addEventListener("keydown", function (e) {
    if (e.key === "Enter") { e.preventDefault(); ap[1].focus(); }
  });

  $("hcpa-form-perso").addEventListener("submit", function (e) {
    e.preventDefault();
    var p = estado.pies[estado.activa];
    var nombres = ["el primer apellido", "el segundo apellido"];
    var primerError = -1;
    [p.ap1, p.ap2].forEach(function (valor, i) {
      var letras = valor.replace(/[^\p{L}]/gu, "").length;
      var msg = !valor ? "Escribe " + nombres[i] + "."
        : letras < CONFIG.minLetras ? "Revisa " + nombres[i] + ": parece incompleto."
        : "";
      marcarError(i, msg);
      if (msg && primerError < 0) primerError = i;
    });
    if (primerError >= 0) { ap[primerError].focus(); return; }

    if (estado.mismos) estado.pies.forEach(function (x) { x.ap1 = p.ap1; x.ap2 = p.ap2; x.ok = true; });
    else p.ok = true;

    var siguiente = primeroPendiente();
    if (siguiente >= 0) {
      estado.activa = siguiente;
      cargarCampos();
      pintarVista();
      refrescar();
      ap[0].focus();
      return;
    }
    refrescar();
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    $("hcpa-ok").scrollIntoView({ block: "nearest", behavior: suave() });
  });

  $("hcpa-mismos").addEventListener("change", function (e) {
    estado.mismos = e.target.checked;
    if (estado.mismos) {
      var base = estado.pies[estado.activa];
      estado.pies.forEach(function (x) { x.ap1 = base.ap1; x.ap2 = base.ap2; x.ok = base.ok; });
    }
    estado.activa = estado.mismos ? 0 : estado.activa;
    cargarCampos();
    pintarVista();
    refrescar();
  });

  /* ---------- Pestañas por unidad ---------- */
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function pintarTabs() {
    var tabs = $("hcpa-tabs");
    tabs.hidden = !multiple();
    $("hcpa-mismos-wrap").hidden = cantidad() < 2;
    if (!multiple()) return;
    tabs.innerHTML = "";
    for (var i = 0; i < cantidad(); i++) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "hcpa-tab";
      b.setAttribute("aria-pressed", String(i === estado.activa));
      b.innerHTML = "Pie " + (i + 1) + (estado.pies[i].ok ? " " + CHECK : "");
      b.setAttribute("aria-label", "Pie " + (i + 1) + (estado.pies[i].ok ? ", confirmado" : ", sin confirmar"));
      b.addEventListener("click", (function (idx) {
        return function () {
          estado.activa = idx;
          cargarCampos();
          pintarVista();
          refrescar();
        };
      })(i));
      tabs.appendChild(b);
    }
  }

  /* ---------- Packs ---------- */
  function pintarPacks() {
    var lista = $("hcpa-packs");
    CONFIG.packs.forEach(function (p, i) {
      var label = document.createElement("label");
      label.className = "hcpa-pack";
      var a = ahorro(p);
      label.innerHTML =
        '<input type="radio" name="hcpa-pack" value="' + i + '"' + (i === estado.pack ? " checked" : "") + ">" +
        (p.chip ? '<span class="hcpa-pack__chip">' + p.chip + "</span>" : "") +
        '<span class="hcpa-pack__emoji" aria-hidden="true">' + p.emoji + "</span>" +
        '<span class="hcpa-pack__txt">' +
          '<span class="hcpa-pack__fila"><span class="hcpa-pack__titulo">' + p.titulo + '</span><span class="hcpa-pack__precio">' + pesos(p.precio) + "</span></span>" +
          '<span class="hcpa-pack__gancho">' + p.gancho + "</span>" +
          '<span class="hcpa-pack__desc">' + p.desc + "</span>" +
          (a > 0 ? '<span class="hcpa-pack__ahorro">Ahorras ' + pesos(a) + " · " + pesos(Math.round(p.precio / p.unidades)) + " c/u</span>" : "") +
        "</span>" +
        '<span class="hcpa-pack__check" aria-hidden="true"></span>';
      label.querySelector("input").addEventListener("change", function () { elegirPack(i, true); });
      lista.appendChild(label);
    });

    var planes = $("hcpa-planes");
    CONFIG.packs.forEach(function (p, i) {
      var a = ahorro(p);
      var div = document.createElement("div");
      div.className = "hcpa-plan" + (i === CONFIG.packDestacado ? " hcpa-plan--destacado" : "");
      div.innerHTML =
        (p.chip ? '<span class="hcpa-plan__cinta">' + p.chip + "</span>" : "") +
        '<p class="hcpa-plan__titulo"><span aria-hidden="true">' + p.emoji + "</span> " + p.gancho + "</p>" +
        '<p class="hcpa-plan__precio">' + pesos(p.precio) + ' <small>' + p.titulo + (p.unidades > 1 ? " · " + pesos(Math.round(p.precio / p.unidades)) + " c/u" : "") + "</small></p>" +
        '<p class="hcpa-plan__det">' + p.desc + "</p>" +
        (a > 0 ? '<p class="hcpa-plan__ahorro">Ahorras ' + pesos(a) + "</p>" : '<p class="hcpa-plan__det">Envío gratis a toda Colombia</p>') +
        '<a class="hcpa-btn hcpa-btn--full" href="#personaliza">Elegir ' + p.titulo + "</a>";
      div.querySelector("a").addEventListener("click", function (e) { e.preventDefault(); elegirPack(i, true); });
      planes.appendChild(div);
    });

    var ultimo = CONFIG.packs[CONFIG.packs.length - 1];
    $("hcpa-desde").innerHTML = "Desde <strong>" + pesos(Math.round(ultimo.precio / ultimo.unidades)) + "</strong> c/u llevando " + ultimo.unidades;
  }

  // irAPersonalizar: tras elegir cantidad, la página baja sola al personalizador.
  function elegirPack(i, irAPersonalizar) {
    estado.pack = i;
    var radio = raiz.querySelector('input[name="hcpa-pack"][value="' + i + '"]');
    if (radio) radio.checked = true;
    if (estado.activa >= cantidad()) estado.activa = 0;
    if (cantidad() < 2) estado.mismos = false;
    $("hcpa-mismos").checked = estado.mismos;
    cargarCampos();
    pintarVista();
    refrescar();
    if (irAPersonalizar) {
      // Espera un instante a que aparezcan las pestañas "Pie 1 / Pie 2" antes de medir.
      setTimeout(function () { $("personaliza").scrollIntoView({ block: "start", behavior: suave() }); }, 150);
    }
  }

  /* ---------- Refresco general ---------- */
  function refrescar() {
    var pack = CONFIG.packs[estado.pack];
    var a = ahorro(pack);
    $("hcpa-precio-actual").textContent = pesos(pack.precio);
    $("hcpa-precio-ahorro").hidden = a <= 0;
    $("hcpa-precio-ahorro").textContent = "Ahorras " + pesos(a);

    pintarTabs();

    var btn = $("hcpa-confirmar");
    btn.hidden = todosOk();
    btn.textContent = multiple() ? "Confirmar pie " + (estado.activa + 1) + " de " + cantidad() : "Confirmar mi personalización";

    var ok = todosOk();
    $("hcpa-ok").hidden = !ok;
    if (ok) {
      var lista = $("hcpa-ok-lista");
      lista.innerHTML = "";
      for (var i = 0; i < cantidad(); i++) {
        var li = document.createElement("li");
        if (multiple()) {
          var s = document.createElement("small");
          s.textContent = "Pie " + (i + 1);
          li.appendChild(s);
        }
        li.appendChild(document.createTextNode(familia(estado.pies[i].ap1, estado.pies[i].ap2)));
        lista.appendChild(li);
      }
      if (estado.mismos) {
        var nota = document.createElement("li");
        nota.innerHTML = "<small>× " + cantidad() + " unidades</small>";
        lista.appendChild(nota);
      }
      $("hcpa-comprar-error").textContent = "";
    }

    $("hcpa-comprar-txt").textContent = "Comprar ahora · " + pesos(pack.precio);
    $("hcpa-comprar").setAttribute("aria-disabled", String(!ok));
    $("hcpa-sticky-l1").textContent = ok ? "Comprar ahora · " + pesos(pack.precio) : "Personalizar el mío";
    // Sin apellidos lleva al personalizador; con apellidos, directo al botón de compra.
    $("hcpa-sticky-btn").setAttribute("href", ok ? "#hcpa-zona-compra" : "#personaliza");
    $("hcpa-prueba").hidden = true;
    sincronizarFormulario();
  }

  /* ---------- Formulario que lee Releasit ---------- */
  // Releasit toma la variante y los properties[...] del formulario que contiene su botón.
  // Solo se llenan los apellidos cuando están confirmados; así un pedido nunca sale sin ellos.
  function sincronizarFormulario() {
    var pack = CONFIG.packs[estado.pack];
    var ok = todosOk();
    $("hcpa-variante").value = pack.variante || "";
    $("hcpa-form-compra").querySelector('[name="quantity"]').value = pack.cantidadForm || 1;
    var cont = $("hcpa-props");
    cont.textContent = "";
    if (ok) {
      var props = propiedades();
      Object.keys(props).forEach(function (clave) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[" + clave + "]";
        input.value = props[clave];
        cont.appendChild(input);
      });
    }
    $("hcpa-rsi").classList.toggle("is-bloqueado", !ok);
    $("hcpa-rsi-bloqueo").hidden = ok;
  }

  // Releasit crea su botón al lado del gancho que está dentro del formulario de compra.
  // Por defecto agrega el producto al carrito con un método que descarta los properties;
  // este ajuste (propio de Releasit) le pide usar el que sí los conserva.
  // Si Releasit no carga, queda el botón propio que va al checkout de Shopify.
  function conectarReleasit(intentos) {
    window._COD_FORM_PRODUCT_PAGE_ADD_MODE_OVERWRITE = "add";
    var boton = $("hcpa-rsi").querySelector("._rsi-buy-now-button");
    if (!boton) {
      if (intentos > 0) setTimeout(function () { conectarReleasit(intentos - 1); }, 300);
      return;
    }
    $("hcpa-rsi").hidden = false;
    $("hcpa-comprar").hidden = true;
    raiz.classList.add("con-releasit");
  }

  // Con la oferta por cantidad, Releasit arma su formulario sin los properties del producto.
  // Cada vez que (re)dibuja su formulario, se agrega item_properties[clave] para nuestras
  // líneas, en el mismo formato que Releasit usa sin oferta (JSON con encodeURI).
  function apellidosEnReleasit() {
    var form = document.getElementById("_rsi-cod-form-modal-form");
    if (!form || !todosOk()) return;
    var valor = encodeURI(JSON.stringify(propiedades()));
    var variantes = CONFIG.packs.map(function (p) { return String(p.variante); });
    form.querySelectorAll('input[name^="item_variant_id["]').forEach(function (v) {
      if (variantes.indexOf(String(v.value)) < 0) return;
      var clave = v.name.slice("item_variant_id".length);
      var campo = form.querySelector('input[name="item_properties' + clave + '"]');
      if (!campo) {
        campo = document.createElement("input");
        campo.type = "hidden";
        campo.name = "item_properties" + clave;
        v.parentNode.insertBefore(campo, v.nextSibling);
      }
      if (campo.value !== valor) campo.value = valor;
    });
  }
  if (tienda && "MutationObserver" in window) {
    new MutationObserver(apellidosEnReleasit).observe(document.body, { childList: true, subtree: true });
  }

  function pedirConfirmacion() {
    var err = $("hcpa-comprar-error");
    var i = primeroPendiente();
    err.textContent = multiple()
      ? "Falta confirmar los apellidos del pie " + (i + 1) + "."
      : "Antes de comprar, confirma los dos apellidos.";
    estado.activa = i;
    cargarCampos();
    pintarVista();
    refrescar();
    $("personaliza").scrollIntoView({ block: "start", behavior: suave() });
  }

  $("hcpa-rsi-bloqueo").addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    pedirConfirmacion();
  });

  /* ---------- Comprar (demo / respaldo sin Releasit) ---------- */
  $("hcpa-comprar").addEventListener("click", function () {
    if (!todosOk()) { pedirConfirmacion(); return; }
    var pack = CONFIG.packs[estado.pack];
    if (tienda) { comprarEnShopify(pack); return; }
    var datos = [["Variante", pack.titulo], ["Total", pesos(pack.precio) + " · envío gratis"]];
    for (var k = 0; k < cantidad(); k++) {
      var etiqueta = cantidad() > 1 ? "Pie " + (k + 1) : "Texto";
      datos.push([etiqueta, "Feliz Navidad para la " + familia(estado.pies[k].ap1, estado.pies[k].ap2)]);
    }
    var dl = $("hcpa-prueba-datos");
    dl.textContent = "";
    datos.forEach(function (d) {
      var dt = document.createElement("dt"); dt.textContent = d[0];
      var dd = document.createElement("dd"); dd.textContent = d[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
    $("hcpa-prueba").hidden = false;
    $("hcpa-prueba").scrollIntoView({ block: "nearest", behavior: suave() });
  });

  /* ---------- Compra real en Shopify ---------- */
  // Los apellidos viajan como propiedades de la línea: Shopify las muestra en el checkout
  // y las guarda en el pedido. Antes de agregar, se quita cualquier pie de árbol que ya
  // estuviera en el carrito para no duplicarlo; los demás productos no se tocan.
  function propiedades() {
    var props = {};
    for (var k = 0; k < cantidad(); k++) {
      var clave = cantidad() > 1 ? "Pie " + (k + 1) : "Personalización";
      props[clave] = "Feliz Navidad para la " + familia(estado.pies[k].ap1, estado.pies[k].ap2);
    }
    return props;
  }

  function pedir(url, cuerpo) {
    return fetch(url, {
      method: cuerpo ? "POST" : "GET",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: cuerpo ? JSON.stringify(cuerpo) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    });
  }

  function comprarEnShopify(pack) {
    var btn = $("hcpa-comprar");
    var txt = $("hcpa-comprar-txt");
    var err = $("hcpa-comprar-error");
    if (pack.disponible === false) { err.textContent = "Esta opción está agotada por ahora."; return; }
    var raizUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    txt.textContent = "Preparando tu pedido…";

    pedir(raizUrl + "cart.js")
      .then(function (carrito) {
        var viejos = carrito.items.filter(function (it) { return it.product_id === tienda.productoId; });
        return viejos.reduce(function (cadena, it) {
          return cadena.then(function () { return pedir(raizUrl + "cart/change.js", { id: it.key, quantity: 0 }); });
        }, Promise.resolve());
      })
      .then(function () {
        return pedir(raizUrl + "cart/add.js", { items: [{ id: pack.variante, quantity: pack.cantidadForm || 1, properties: propiedades() }] });
      })
      .then(function () { window.location.href = raizUrl + "checkout"; })
      .catch(function () {
        btn.removeAttribute("aria-busy");
        btn.disabled = false;
        txt.textContent = "Comprar ahora · " + pesos(pack.precio);
        err.textContent = "No pudimos agregar tu pedido. Revisa tu conexión e inténtalo de nuevo.";
      });
  }

  /* ---------- Vista de cerca / completa ---------- */
  var marco = raiz.querySelector(".hcpa-vista__marco");
  raiz.querySelectorAll(".hcpa-seg__btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var vista = btn.getAttribute("data-vista");
      $("hcpa-svg").setAttribute("viewBox", CONFIG.vistas[vista]);
      marco.classList.toggle("is-completo", vista === "completo");
      raiz.querySelectorAll(".hcpa-seg__btn").forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
    });
  });

  /* ---------- Galería ---------- */
  var pista = $("hcpa-galeria");
  var items = pista.children;
  var puntos = $("hcpa-puntos");
  for (var g = 0; g < items.length; g++) puntos.appendChild(document.createElement("span"));
  function fotoActual() { return Math.round(pista.scrollLeft / pista.clientWidth); }
  function pintarPuntos() {
    var n = fotoActual();
    Array.prototype.forEach.call(puntos.children, function (s, i) { s.classList.toggle("is-activo", i === n); });
  }
  pista.addEventListener("scroll", function () { window.requestAnimationFrame(pintarPuntos); }, { passive: true });
  raiz.querySelectorAll(".hcpa-galeria__flecha").forEach(function (b) {
    b.addEventListener("click", function () {
      var n = (fotoActual() + Number(b.getAttribute("data-dir")) + items.length) % items.length;
      pista.scrollTo({ left: n * pista.clientWidth, behavior: suave() });
    });
  });
  pintarPuntos();

  /* ---------- CTA fijo en celular ---------- */
  var sticky = $("hcpa-sticky");
  if ("IntersectionObserver" in window) {
    var visibles = new Set();
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target);
      });
      sticky.classList.toggle("is-oculto", visibles.size > 0);
    });
    [$("hcpa-h1"), $("personaliza"), raiz.querySelector(".hcpa-comprar")].forEach(function (el) { io.observe(el); });
  } else {
    sticky.classList.remove("is-oculto");
  }

  /* ---------- Enlaces internos ---------- */
  // El navegador ignora un enlace #ancla si la URL ya termina en esa ancla; aquí se
  // desplaza siempre (personalizador o botón de compra), toque el botón que toque.
  raiz.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented) return;
    var destino = document.getElementById(a.getAttribute("href").slice(1));
    if (!destino || !raiz.contains(destino)) return;
    e.preventDefault();
    destino.scrollIntoView({ block: "start", behavior: suave() });
  });

  /* ---------- Arranque ---------- */
  pintarPacks();
  cargarCampos();
  pintarVista();
  refrescar();
  if (tienda) conectarReleasit(20);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pintarVista);
})();
